import { UploadMediaRequest } from "@/api/events/models/EventInput";
import axios from "axios";

export const createEventApi = async (token: string, data: any) => {
  try {
    return await axios.post(
      `${import.meta.env.VITE_API_BASE_URL}/event/v1/event`,
      data,
      {
        headers: {
          Authorization: token,
        },
      }
    );
  } catch (error) {
    return error;
  }
};

export const uploadMediaApi = async (
  token: string,
  data: UploadMediaRequest
) => {
  try {
    return await axios.post(
      `${import.meta.env.VITE_API_BASE_URL}/event/v1/upload-media`,
      data,
      {
        headers: {
          Authorization: token,
        },
      }
    );
  } catch (error) {
    return error;
  }
};

export const listViewEvents = async (token: string) => {
  try {
    return await axios.get(
      `${import.meta.env.VITE_API_BASE_URL}/event/v1/list-view-events`,
      {
        headers: {
          Authorization: token,
        },
      }
    );
  } catch (error) {
    return error;
  }
};

export const countAttendees = async (token: string) => {
  try {
    return await axios.get(
      `${import.meta.env.VITE_API_BASE_URL}/core/v1/count-attendees`,
      {
        headers: {
          Authorization: token,
        },
      }
    );
  } catch (error) {
    return error;
  }
};

export const listTeamMembers = async (token: string) => {
  try {
    return await axios.get(
      `${import.meta.env.VITE_API_BASE_URL}/teams/v1/list-team-members`,
      {
        headers: {
          Authorization: token,
        },
      }
    );
  } catch (error) {
    return error;
  }
};

export const countTeamMembers = async (token: string) => {
  try {
    return await axios.get(
      `${import.meta.env.VITE_API_BASE_URL}/core/v1/count-team-members`,
      {
        headers: {
          Authorization: token,
        },
      }
    );
  } catch (error) {
    return error;
  }
};
